export const GET_LOADING_DATA = "GET_LOADING_DATA";
export const SET_USERS = "SET_USERS";
export const UPDATE_BALANCE = "UPDATE_BALANCE";
export const SET_TOKENS = "SET_TOKENS";
export const LOGOUT = "LOGOUT";
export const BID = "BID";
export const RESUME_DRAFT = "RESUME_DRAFT";
export const REMOVE_BID = "REMOVE_BID";
export const THEME_MODE = "THEME_MODE";
export const SET_TIMEZOME = "SET_TIMEZOME";
export const SET_PAGE_PERMISSIONS = "SET_PAGE_PERMISSIONS";
export const PAGE_PERMISSIONS_ERROR = "PAGE_PERMISSIONS_ERROR";
